import { Head, router } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { preferencesPath, sessionPath } from "@travily/routes";
import type MenuShow from "@travily/types/pages/MenuShow";
import { useCallback, useState } from "react";
import { LocaleModal, type LocaleModalTab } from "@/components/LocaleModal/LocaleModal";
import { useIntercom } from "@/hooks/use-intercom";
import { PageFrame } from "@/layouts/page-frame";
import { MenuView } from "./show.view";

interface MenuShowPageProps extends MenuShow {
  // currentMode is derived from layout context; not server-provided.
}

const MenuShowPage = ({ has_listings }: MenuShowPageProps) => {
  const [isLocaleModalOpen, setIsLocaleModalOpen] = useState(false);
  const [localeModalTab, setLocaleModalTab] = useState<LocaleModalTab>("language");

  const openLocaleModal = useCallback((tab: LocaleModalTab) => {
    setLocaleModalTab(tab);
    setIsLocaleModalOpen(true);
  }, []);

  const handleLocaleSelect = useCallback((newLocale: string) => {
    setIsLocaleModalOpen(false);
    router.patch(
      preferencesPath(),
      { locale: newLocale },
      {
        onSuccess: () => {
          const path = globalThis.location.pathname;
          globalThis.location.replace(path);
        },
      },
    );
  }, []);

  const handleCurrencySelect = useCallback((newCurrency: string) => {
    setIsLocaleModalOpen(false);
    router.patch(preferencesPath(), { currency: newCurrency }, { preserveState: false });
  }, []);

  const handleLogout = useCallback(() => router.delete(sessionPath()), []);

  const { openMessenger } = useIntercom();

  return (
    <PageFrame mode="explorer">
      <Head title={t("web.menu.show.meta_title")} />
      <MenuView
        mode="explorer"
        hasListings={has_listings}
        onLanguagesAndCurrency={() => openLocaleModal("language")}
        onGetHelp={openMessenger}
        onLogout={handleLogout}
      />
      <LocaleModal
        isOpen={isLocaleModalOpen}
        onOpenChange={setIsLocaleModalOpen}
        currentLocale=""
        currentCurrency=""
        suggestedLocales={[]}
        defaultTab={localeModalTab}
        onLocaleSelect={handleLocaleSelect}
        onCurrencySelect={handleCurrencySelect}
      />
    </PageFrame>
  );
};

export default MenuShowPage;
